import { PlaybookReportType } from '@driftt/api-types/dist/playbook'

export const CHAT_REPORT_TYPES = [
  PlaybookReportType.BOOK_MORE_MEETINGS,
  PlaybookReportType.MORE_QUALIFIED_CONVERSATIONS,
  PlaybookReportType.MORE_SALES_CONVERSATIONS,
  PlaybookReportType.DRIVE_TRAFFIC_TARGETED_MESSAGE,
  PlaybookReportType.PROMOTION_FULL_SCREEN_TAKEOVER,
  PlaybookReportType.TALK_TO_YOUR_OUTBOUND_PROSPECTS,
  PlaybookReportType.BUILD_A_SUBSCRIBER_LIST,
  PlaybookReportType.EMPTY_LEADBOT,
  PlaybookReportType.EMPTY_SLIDER,
  PlaybookReportType.EMPTY_TAKEOVER,
  PlaybookReportType.EMPTY_WELCOME_MESSAGE,
  PlaybookReportType.NPS_BOT,
  PlaybookReportType.ABM,
  PlaybookReportType.LANDING_PAGE_LEADBOT,
  PlaybookReportType.VSB_DEFAULT_PLAYBOOK,
  PlaybookReportType.CONVERSATION_STARTER_BOT,
  PlaybookReportType.RETARGETING_BOT,
  PlaybookReportType.PRICING_PAGE_BOT,
  PlaybookReportType.SECOND_NET_BOT,
  PlaybookReportType.ABM_HOMEPAGE_BOT,
  PlaybookReportType.PAID_TRAFFIC_BOT,
  PlaybookReportType.FORM_REPLACER_CLP,
  PlaybookReportType.CONVO_CONTENT_CLP,
  PlaybookReportType.ENTERPRISE_BOT,
  PlaybookReportType.AI_TOPICS,
  PlaybookReportType.ENGAGE_ALL_BOT,
  PlaybookReportType.SKIP_THE_FORM_BOT,
  PlaybookReportType.VISITOR_RETARGETING_BOT,
  PlaybookReportType.BLOG_BOT,
  PlaybookReportType.PAID_AD_CONVERTER_BOT,
  PlaybookReportType.TARGET_ACCOUNTS_BOT,
  PlaybookReportType.MEETING_BOOKING_BOT,
]

export const FAST_LANE_REPORT_TYPES = [
  PlaybookReportType.FORM_SUBMISSION_FAST_LANE,
]

export const EMAIL_FUNNEL_METRIC_KEYS = Object.freeze([
  'SENT',
  'DELIVERED',
  'OPENED',
  'CLICKED',
  'REPLIED',
])

const PLAYBOOKS_TYPE_NAMES = Object.freeze({
  BOT: 'Bot',
  EMAIL_CAPTURE: 'Email capture',
  SLIDER: 'Slider message',
  TAKEOVER: 'Full screen takeover',
  LANDING_PAGE: 'Landing page',
  SALES_SEQUENCE: 'Sales sequence',
  EMAIL: 'Triggered email',
  WELCOME_MESSAGE: 'Welcome message',
  ABM_WELCOME_MESSAGE: 'ABM welcome message',
  OUTBOUND_WELCOME_MESSAGE: 'Outbound welcome message',
})

export const METRIC_NAMES = Object.freeze({
  conversations: 'Conversations',
  conversationsHeld: 'Conversations held',
  endUserEngaged: 'Engaged',
  formFills: 'Forms submitted',
  impressions: 'Impressions',
  leadsCaptured: 'Emails captured',
  meetingsBooked: 'Meetings booked',
  sent: 'Sends',
  routedConversations: 'Routed conversations',
  overallBuyerSentiment: 'Visitor sentiment',
})

export const NAMES_BY_REPORT_TYPE = Object.freeze({
  [PlaybookReportType.TALK_TO_YOUR_OUTBOUND_PROSPECTS]:
    PLAYBOOKS_TYPE_NAMES.OUTBOUND_WELCOME_MESSAGE,
  [PlaybookReportType.BUILD_A_SUBSCRIBER_LIST]:
    PLAYBOOKS_TYPE_NAMES.EMAIL_CAPTURE,
  [PlaybookReportType.EMPTY_LEADBOT]: PLAYBOOKS_TYPE_NAMES.BOT,
  [PlaybookReportType.ENTERPRISE_BOT]: PLAYBOOKS_TYPE_NAMES.BOT,
  [PlaybookReportType.EMPTY_SLIDER]: PLAYBOOKS_TYPE_NAMES.SLIDER,
  [PlaybookReportType.EMPTY_TAKEOVER]: PLAYBOOKS_TYPE_NAMES.TAKEOVER,
  [PlaybookReportType.EMPTY_WELCOME_MESSAGE]:
    PLAYBOOKS_TYPE_NAMES.WELCOME_MESSAGE,
  [PlaybookReportType.ABM]: PLAYBOOKS_TYPE_NAMES.ABM_WELCOME_MESSAGE,
  [PlaybookReportType.LANDING_PAGE_LEADBOT]: PLAYBOOKS_TYPE_NAMES.LANDING_PAGE,
  [PlaybookReportType.CONVERSATION_STARTER_BOT]: PLAYBOOKS_TYPE_NAMES.BOT,
  [PlaybookReportType.RETARGETING_BOT]: PLAYBOOKS_TYPE_NAMES.BOT,
  [PlaybookReportType.PRICING_PAGE_BOT]: PLAYBOOKS_TYPE_NAMES.BOT,
  [PlaybookReportType.SECOND_NET_BOT]: PLAYBOOKS_TYPE_NAMES.BOT,
  [PlaybookReportType.ABM_HOMEPAGE_BOT]: PLAYBOOKS_TYPE_NAMES.BOT,
  [PlaybookReportType.PAID_TRAFFIC_BOT]: PLAYBOOKS_TYPE_NAMES.BOT,
  [PlaybookReportType.FORM_REPLACER_CLP]: PLAYBOOKS_TYPE_NAMES.LANDING_PAGE,
  [PlaybookReportType.CONVO_CONTENT_CLP]: PLAYBOOKS_TYPE_NAMES.LANDING_PAGE,
  [PlaybookReportType.OUTBOUND_SEQUENCE]: PLAYBOOKS_TYPE_NAMES.SALES_SEQUENCE,
  [PlaybookReportType.MARKETING_SEQUENCE]: PLAYBOOKS_TYPE_NAMES.EMAIL,
  [PlaybookReportType.MARKETING_ONE_TIME_SEQUENCE]: PLAYBOOKS_TYPE_NAMES.EMAIL,
  [PlaybookReportType.BLOG_NURTURE]: PLAYBOOKS_TYPE_NAMES.EMAIL,
  [PlaybookReportType.FORM_SUBMISSION_FAST_LANE]: PLAYBOOKS_TYPE_NAMES.BOT,
  [PlaybookReportType.AI_TOPICS]: PLAYBOOKS_TYPE_NAMES.BOT,
  [PlaybookReportType.ENGAGE_ALL_BOT]: PLAYBOOKS_TYPE_NAMES.BOT,
  [PlaybookReportType.SKIP_THE_FORM_BOT]: PLAYBOOKS_TYPE_NAMES.BOT,
  [PlaybookReportType.VISITOR_RETARGETING_BOT]: PLAYBOOKS_TYPE_NAMES.BOT,
  [PlaybookReportType.BLOG_BOT]: PLAYBOOKS_TYPE_NAMES.BOT,
  [PlaybookReportType.PAID_AD_CONVERTER_BOT]: PLAYBOOKS_TYPE_NAMES.BOT,
  [PlaybookReportType.TARGET_ACCOUNTS_BOT]: PLAYBOOKS_TYPE_NAMES.BOT,
  [PlaybookReportType.MEETING_BOOKING_BOT]: PLAYBOOKS_TYPE_NAMES.BOT,

  // The rest of types seen below are no longer available to customers in the marketplace
  // Based on: https://github.com/Driftt/playbook-editor-web/blob/master/src/constants/types.js
  // https://github.com/Driftt/customer-web/blob/master/src/scripts/app/modules/playbook/constants.js
  [PlaybookReportType.BOOK_MORE_MEETINGS]: PLAYBOOKS_TYPE_NAMES.BOT,
  [PlaybookReportType.MORE_QUALIFIED_CONVERSATIONS]: PLAYBOOKS_TYPE_NAMES.BOT,
  [PlaybookReportType.MORE_SALES_CONVERSATIONS]: PLAYBOOKS_TYPE_NAMES.SLIDER,
  [PlaybookReportType.DRIVE_TRAFFIC_TARGETED_MESSAGE]:
    PLAYBOOKS_TYPE_NAMES.WELCOME_MESSAGE,
  [PlaybookReportType.PROMOTION_FULL_SCREEN_TAKEOVER]:
    PLAYBOOKS_TYPE_NAMES.TAKEOVER,
  [PlaybookReportType.NPS_BOT]: PLAYBOOKS_TYPE_NAMES.BOT,
  [PlaybookReportType.VSB_DEFAULT_PLAYBOOK]: PLAYBOOKS_TYPE_NAMES.BOT,
  [PlaybookReportType.SEND_AN_AUTOMATED_EMAIL]: PLAYBOOKS_TYPE_NAMES.EMAIL,
  [PlaybookReportType.SEND_A_ONETIME_EMAIL]: PLAYBOOKS_TYPE_NAMES.EMAIL,
  [PlaybookReportType.SEND_A_ONETIME_OUTBOUND_EMAIL]:
    PLAYBOOKS_TYPE_NAMES.EMAIL,
  [PlaybookReportType.NEW_BLOG_CONTENT]: PLAYBOOKS_TYPE_NAMES.EMAIL,
  [PlaybookReportType.NEWSLETTER]: PLAYBOOKS_TYPE_NAMES.EMAIL,
  [PlaybookReportType.PRODUCT_ANNOUNCEMENT]: PLAYBOOKS_TYPE_NAMES.EMAIL,
  [PlaybookReportType.ABANDONED_BOOK_A_MEETING]: PLAYBOOKS_TYPE_NAMES.EMAIL,
})

export const PLAYBOOKS_WITH_BOT_CONVERSATIONS = [
  PlaybookReportType.EMPTY_LEADBOT,
  PlaybookReportType.ENTERPRISE_BOT,
  PlaybookReportType.BOOK_MORE_MEETINGS,
  PlaybookReportType.MORE_QUALIFIED_CONVERSATIONS,
  PlaybookReportType.LANDING_PAGE_LEADBOT,
  PlaybookReportType.VSB_DEFAULT_PLAYBOOK,
  PlaybookReportType.CONVERSATION_STARTER_BOT,
  PlaybookReportType.RETARGETING_BOT,
  PlaybookReportType.PRICING_PAGE_BOT,
  PlaybookReportType.SECOND_NET_BOT,
  PlaybookReportType.ABM_HOMEPAGE_BOT,
  PlaybookReportType.PAID_TRAFFIC_BOT,
  PlaybookReportType.FORM_REPLACER_CLP,
  PlaybookReportType.CONVO_CONTENT_CLP,
  PlaybookReportType.NPS_BOT,
  PlaybookReportType.FORM_SUBMISSION_FAST_LANE,
  PlaybookReportType.AI_TOPICS,
  PlaybookReportType.ENGAGE_ALL_BOT,
  PlaybookReportType.SKIP_THE_FORM_BOT,
  PlaybookReportType.VISITOR_RETARGETING_BOT,
  PlaybookReportType.BLOG_BOT,
  PlaybookReportType.PAID_AD_CONVERTER_BOT,
  PlaybookReportType.TARGET_ACCOUNTS_BOT,
]
